import styled from "styled-components";
import {SliceFillDefaultBox} from "./slice-fill.default.box";

export const SliceFillMrGreenBox = styled(SliceFillDefaultBox)`
    filter: drop-shadow(0px 4px 12px #015536);
`;